import React from "react";
import CardsBlock from "./cardsBlock";
import {
  cardsData3,
  cardsData4,
  headers,
  headersPrice,
  tablePrice,
} from "../data";
import Price from "./price";
import BtnBrif from "../btns/btnBrif";
import TablePrice from "./tablePrice";

export default function WebBlock({ variant }) {
  return (
    <div className="container">
      <div className="webBlock">
        <CardsBlock cards={cardsData3} />
        <h2 className="title">{headers[5].header}</h2>
        <h3 className="priceTitle">{headersPrice[0].header}</h3>
        <Price
          title="Лэндинг Пейдж"
          text="Сайт, который отлично подойдет для тех кто хочет рассказать о своем бизнесе, товаре или услуге (автосервис, юрисприденция, фотографам и тд.). Мы запустим Ваш проект быстро и с комфортом для вас. Спокойно занимайтесь бизнесом, а мы займемся сайтом."
          text2="На сайте разместим информацию о вашей услуге, товаре или категориях для заказа. Добавим форму обратной связи (сообщения — на вашу почту), ссылки на мессенджеры и контакты. Подберём изображения, шрифты и цвета под тематику. Адаптивный дизайн."
          price="от 10 000 ₽"
          text3="Срок запуска — от 3 до 5 дней."
        />
        <h3 className="priceTitle">{headersPrice[1].header}</h3>
        <Price
          title="Готовое решение"
          text="Коммерческий или информационный сайт идеально подойдет для размещения широкого спектра услуг или публикацию различных статей. Оптимален для продвижения в сети Яндекс и Google."
          text2="Мы предложим несколько вариантов уже готовых решений, в которых продуманна структура и дизайн."
          price="от 10 000 ₽"
          text3="Срок запуска — от 3 до 5 дней."
        />
        <Price
          title="С уникальным дизайном"
          text="Готовый сайт с уникальным дизайном. Проект делается индивидуально под Вас."
          text2="Если Вам нужен уникальный дизайн, то мы предложим вам несколько вариантов,а после публикации уберем его из нашего каталога."
          price="от 20 000 ₽"
          text3="Срок запуска — от 3 до 5 дней."
        />
        <Price
          title="С уникальным дизайном, адаптированным под Ваши требования"
          text="Готовый сайт с уникальным дизайном адаптированный под Ваши требования (брендлук, цвета, шрифты, картинки, слайды и тд). Проект делается индивидуально под Вас и не публикуется в нашем каталоге сайтов."
          text2="Подходит тем, кто уже представляет дизайн сайта. Подберём шрифты, цвета и поможем с логотипом под брендбук. Реализуем все ваши идеи — типовые и уникальные. Срок запуска — от 2 до 4 недель."
          price="от 40 000 ₽"
          text3="Срок запуска — от 2 до 4 недель."
        />
        <h3 className="priceTitle">{headersPrice[2].header}</h3>
        <Price
          title="Интернет-магазин"
          text="Полнофункицональный интернет-магазин с каталогом товаров, корзиной, настраиваемые скидки, система платежей и доставки."
          text2="У нас есть готовые решения с крутым дизайном, функционалом, фильтрами и настройками. Все сайты адаптированы под мобильные устройства. Подключаем к нашему B2B: категории, товары с описаниями и фото, наценки — всё загружается на ваш сайт. Заказы поступают в личный кабинет и на почту."
          price="от 150 000 ₽"
          text3="Срок запуска — от 3 до 5 дней."
        />
        <Price
          title="Интернет-магазин с уникальным дизайном"
          text="Полнофункицональный интернет-магазин с уникальным дизайном, с каталогом товаров, корзиной, настраиваемые скидки, система платежей и доставки."
          text2="Разработаем фирменный брендбук: логотип, цвета, шрифты, слайды и изображения. Реализуем любые идеи — шаблонные и уникальные. Создадим интернет-магазин с индивидуальным адаптивным дизайном, продуманными фильтрами, карточками товара, иконками и анимацией. Подключим сайт к нашему B2B — категории, товары с описаниями и фото, наценки загружаются автоматически. Заказы поступают в личный кабинет и на почту."
          price="от 150 000 ₽"
          text3="Срок запуска — от 3 до 5 дней."
        />
        <BtnBrif title="Заполнить бриф" link="/brif" />
        <h3 className="priceTitle">{headersPrice[3].header}</h3>
        <TablePrice data={tablePrice} />
        <h3 className="priceTitle">{headersPrice[4].header}</h3>
        <CardsBlock cards={cardsData4} variant="cardBlock2" />
      </div>
    </div>
  );
}
